import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import course05 from "../../../course/course-05/course";
import lesson0219 from "../../course-02/lesson-19/lesson";
import lesson0221 from "../../course-02/lesson-21/lesson";
import lesson0512 from "../../course-05/lesson-12/lesson";
import lesson0513 from "../../course-05/lesson-13/lesson";
import lesson0514 from "../../course-05/lesson-14/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "f7ca6377-e259-4cd0-9cc1-e3123359aba1",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0219),
    lesson: lesson0219,
  },
  {
    id: "36f283b8-35fc-4ca2-8e3b-6d9e56e75ca5",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0221),
    lesson: lesson0221,
  },
  {
    id: "75049d90-9f9d-4082-ad91-b58fdb72011c",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0512),
    lesson: lesson0512,
  },
  {
    id: "f20b2201-040e-4974-8ee0-398db9519862",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0513),
    lesson: lesson0513,
  },
  {
    id: "8d02c461-6b8a-4880-ad7a-fe93d0e611eb",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0514),
    lesson: lesson0514,
  },
];

export default lessonLinks;
